module.exports = __webpack_public_path__ + "static/media/business_sales_leads.8766adab.jpg";